import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=2b5748ef"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5748ef')) {
      api.createRecord('2b5748ef', component.options)
    } else {
      api.reload('2b5748ef', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=2b5748ef", function () {
      api.rerender('2b5748ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/detail-card/HomePage.vue"
export default component.exports